import { Svg } from 'common/assets'
import { EColors } from 'common/styles'
import styled, { keyframes } from 'styled-components'

const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(60px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`
export const AnimatedImage = styled.img<{ $delay?: number }>`
  opacity: 0;
  animation: ${fadeInUp} 0.5s ease-out forwards;
  animation-delay: ${({ $delay }) => $delay || 0}s;
  width: 100%;
  object-fit: cover;
`
export const ContantContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 72px;
  max-width: 1440px;
  margin: 0 auto;
  @media screen and (max-width: 1199px) {
    padding: 0 16px;
  }
`

export const Container = styled.section`
  position: relative;
  overflow: hidden;
  width: 100%;
  /* padding-bottom: 52px; */
  background-color: ${EColors.bg_light};

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    background-image: url('${Svg.SignThree}'), url('${Svg.SignFour}'),
      url('${Svg.SignTwo}');
    background-repeat: no-repeat;
    background-position: left 32px top -50px, left 60% top -50px,
      right 16px top -50px;
    background-size: 83px;
    animation: bgFloatIn 1s ease-out forwards;
    z-index: 0;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  @keyframes bgFloatIn {
    to {
      background-position: left 32px top 130px, left 60% top 200px,
        right 16px top 130px;
    }
  }

  @media (min-width: 768px) {
    &::before {
      background-size: 114px, 100px;
      animation: bgFloatIn768 1s ease-out forwards;
    }

    @keyframes bgFloatIn768 {
      to {
        background-position: left 32px top 200px, left 60% top 120px,
          right 16px top 110px;
      }
    }
  }

  @media (min-width: 1200px) {
    &::before {
      background-size: 146px, 100px;
      animation: bgFloatIn1200 1s ease-out forwards;
    }

    @keyframes bgFloatIn1200 {
      to {
        background-position: left 32px top 60px, left 63% top 190px,
          right 16px top 150px;
      }
    }
  }

  @media screen and (min-width: 1440px) {
    background-position: left 32px top 60px, left 63% top 100px,
      right 16px top 200px;
    background-size: 146px, 120px;
  }
`

export const TitleWrapper = styled.div`
  opacity: 0;
  transform: translateY(-100%);
  animation: appearence 0.4s ease-out 0.2s forwards;

  @keyframes appearence {
    from {
      opacity: 0;
      transform: translateY(-100%);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`

export const Title = styled.h2`
  font-size: 28px;
  margin-top: 20px;
  margin-bottom: 40px;
  font-weight: 500;
  color: ${EColors.primary_500};
  @media (min-width: 768px) {
    font-size: 38px;
    margin-top: 25px;
  }
  @media (min-width: 1000px) {
    font-size: 48px;
    margin-top: 25px;
    margin-left: 40px;
    margin-bottom: 30px;
  }
  @media (min-width: 1200px) {
    font-size: 68px;
    margin-top: 30px;
    margin-left: 100px;
    margin-bottom: 53px;
  }
`

export const MobileImagesWrap = styled.div<{ $count?: number }>`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;

  img {
    width: 100%;
    object-fit: cover;
  }

  img:nth-child(1),
  img:nth-child(2) {
    height: 260px;
    width: calc(50% - 6px);
  }

  ${({ $count }) =>
    $count === 3 &&
    `
    img:nth-child(3) {
      height: 190px;
    }
  `}

  @media (min-width: 768px) {
    display: none;
  }
`

export const LinksList = styled.div`
  width: 100%;
  margin-top: 40px;
  margin-bottom: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  height: 50px;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  a {
    text-decoration: none;
    color: ${EColors.primary_500};
    display: flex;
    justify-content: center;
    height: 100%;
    align-items: center;
    max-width: 200px;
    position: relative;

    &:last-child {
      height: 40px;
      padding: 0 14px;
      width: fit-content;
      &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 1px solid ${EColors.primary_500};
        border-radius: 80% / 80%;
        transform: rotate(-2.7deg);
        pointer-events: none;
      }
    }
  }

  @media (min-width: 768px) {
    width: 420px;
    margin-top: 10px;

    a {
      font-size: 16px;
    }
  }
  @media (min-width: 1000px) {
    margin-bottom: 4px;
  }
  @media (min-width: 1200px) {
    a {
      &:last-child {
        height: 50px;
        width: 240px;
      }
    }
  }
`

export const MobileTextDescription = styled.p`
  font-size: 14px;
  line-height: 1.47;
  color: ${EColors.neutral_800};
  white-space: pre-wrap;
  font-family: 'Circle', sans-serif;

  @media (min-width: 768px) {
    display: none;
  }
`
export const DesktopWrap = styled.div`
  display: none;
  max-width: 1440px;
  margin: 0 auto;
  @media (min-width: 768px) {
    display: flex;
    gap: 12px;
  }
  @media (min-width: 1200px) {
    gap: 24px;
  }
`
export const ImageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  img {
    width: 100%;
  }
  @media (min-width: 1000px) {
    &:nth-child(1) {
      img {
        max-height: 385px;
      }
    }
    &:nth-child(2) {
      img {
        max-height: 620px;
      }
    }
    &:nth-child(3) {
      img {
        max-height: 620px;
      }
    }
  }
  @media (min-width: 1200px) {
    gap: 24px;
  }
  p {
    color: ${EColors.neutral_800};
    line-height: 1.44;
    font-size: 18px;
    white-space: pre-wrap;
    font-family: 'Circle', sans-serif;
    text-indent: 40px;
  }
`
